var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"ml-n2 disable-select",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{staticClass:"disable-select"},[_vm._t("default",function(){return [_vm._v("Default Page Header text...")]})],2),_c('v-divider',{attrs:{"id":"headerDivider"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }